import { Component, Input, OnChanges } from '@angular/core';
import Article from '../../../smoothr-web-app-core/models/Article';
import { numberD } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-allergens-info',
	templateUrl: './allergens-info.component.html',
	styleUrl: './allergens-info.component.scss',
})
export class AllergensInfoComponent implements OnChanges {
	@Input() article: Article;

	numberD = numberD;
	allergens: string[];
	additives: string[];
	nutrients: { [key: string]: string[] };
	emptySortedNutritions = {
		unit: null,
		energyKcalPer100g: null,
		energyKcalPerPortion: null,
		energyKjPerPortion: null,
		energyKjPer100g: null,
		fatPerPortion: null,
		fatPer100g: null,
		saturatesPerPortion: null,
		saturatesPer100g: null,
		carbohydratePerPortion: null,
		carbohydratePer100g: null,
		sugarPerPortion: null,
		sugarPer100g: null,
		proteinPerPortion: null,
		proteinPer100g: null,
		saltPerPortion: null,
		saltPer100g: null,
		highFat: false,
		highSugar: false,
		portionInG: null,
		_id: null,
		createdAt: null,
		updatedAt: null
	};

	constructor() {}

	ngOnChanges() {
		if (!this.allergens) {
			this.allergens = Object.entries(this.article.compound.allergens).reduce((acc, item) => {
				if (item[1] && !['_id', 'createdAt', 'updatedAt'].includes(item[0])) {
					acc.push(item[0].split(/(?=[A-Z])/)[0]);
				}
				return acc;
			}, []);
		}

		if (!this.additives) {
			this.additives = Object.entries(this.article.compound.additives).reduce((acc, item) => {
				if (item[1] && !['_id', 'createdAt', 'updatedAt'].includes(item[0])) {
					acc.push(item[0]);
				}
				return acc;
			}, []);
		}

		if (!this.nutrients) {
			this.nutrients = Object.entries(Object.assign(this.emptySortedNutritions, this.article.nutritions)).reduce((acc, item) => {
				if (!['_id', 'createdAt', 'updatedAt', 'unit'].includes(item[0]) && item[1]) {
					const nutrientKey = item[0].split('P')[0];
					if (!acc[nutrientKey]) {
						acc[nutrientKey] = [];
					}
					const unit = item[0].includes('Kj') ? ' kj' : nutrientKey.includes('Kcal') ? ' kcal' : ' g';
					item[0].includes('100g')
						? acc[nutrientKey].unshift(numberD(item[1]) + unit)
						: acc[nutrientKey].push(numberD(item[1]) + unit);
				}
				return acc;
			}, {});
		}

		console.log(Object.entries(Object.assign(this.emptySortedNutritions, this.article.nutritions)));
		console.log(Object.entries(this.nutrients));
	}

	keepOrder = (a: any, b: any): number => {
		return 0;
	};

	isAllergens() {
		if (!this.article?.compound?.allergens) {
			return null;
		}
		return Object.values(this.article?.compound?.allergens).find(it => it === true);
	}

	isAddit() {
		if (!this.article?.compound?.additives) {
			return null;
		}
		return Object.values(this.article?.compound?.additives).find(it => it === true);
	}

	isHaveAnyValueMoreZero(article: any) {
		if (!article?.nutritions) {
			return null;
		}
		return Object.values(article.nutritions)
			.map(it => (it ? numberD(it) : -1))
			.filter(it => typeof it === 'number')
			.some(it => +it >= 0);
	}
}
